import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api } from "../lib/api";
import { Checkbox } from "./ui/checkbox";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function BrandFilter({ sp, set }) {
  const [brands, setBrands] = useState([]);
  const [q, setQ] = useState("");
  const [all, setAll] = useState(false);
  const category = sp.get("category") || "";
  const sub = sp.get("sub") || "";
  const picked = (sp.get("brands") || "").split(",").filter(Boolean);

  useEffect(() => { api.get("/brands", { params: { category, sub, q: sp.get("q") || "" } }).then((r) => setBrands(r.data)); }, [category, sub, sp.get("q")]); // eslint-disable-line

  const toggle = (name) => {
    const next = picked.includes(name) ? picked.filter((b) => b !== name) : [...picked, name];
    set("brands", next.join(","));
  };
  const list = brands.filter((b) => b.name.toLowerCase().includes(q.toLowerCase()));
  const shown = all || q ? list : list.slice(0, 8);

  return (
    <div data-testid="brand-filter">
      <div className="flex items-center mb-3">
        <p className="text-xs uppercase tracking-wider text-slate-500">Brand</p>
        {picked.length > 0 && <button data-testid="brand-filter-clear" onClick={() => set("brands", "")} className="ml-auto text-xs text-[#ff5500]">Clear ({picked.length})</button>}
      </div>
      {brands.length > 8 && (
        <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-3 h-9 mb-3">
          <Search size={14} className="text-slate-500" />
          <input data-testid="brand-filter-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search brand" className="bg-transparent outline-none text-sm flex-1 min-w-0" />
        </div>
      )}
      <div className="space-y-1 max-h-72 overflow-y-auto pr-1">
        {shown.map((b) => (
          <label key={b.name} data-testid={`brand-option-${slug(b.name)}`} className="flex items-center gap-3 px-2 py-1.5 rounded-lg hover:bg-white/5 cursor-pointer text-sm">
            <Checkbox data-testid={`brand-checkbox-${slug(b.name)}`} checked={picked.includes(b.name)} onCheckedChange={() => toggle(b.name)} />
            <span className={picked.includes(b.name) ? "text-white font-semibold" : "text-slate-300"}>{b.name}</span>
            <span className="ml-auto text-xs text-slate-500">{b.count}</span>
          </label>
        ))}
        {!shown.length && <p className="text-xs text-slate-500 px-2">No brands found</p>}
      </div>
      {!q && list.length > 8 && (
        <button data-testid="brand-filter-more" onClick={() => setAll((v) => !v)} className="mt-2 text-xs font-semibold text-[#00f0ff]">{all ? "Show less" : `+ ${list.length - 8} more`}</button>
      )}
    </div>
  );
}
